import { captureAttribution } from '~/lib/attribution';

export default defineNuxtPlugin(() => {
  captureAttribution();
});
